export default "/images/vendor/flag-icon-css/flags/4x3/gb-sct.svg?4743f1b0f3ffe8d16ba501687a3dc597";